import { memo } from 'react'

import { Faq } from './FaqTab'

interface FaqItemProps {
  faq: Faq
  onChange: (faq: Faq) => void
  onDelete: (id: string) => void
}

const FaqItem: React.FC<FaqItemProps> = memo(({ faq, onChange, onDelete }) => {
  const onQuestionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...faq, question: e.target.value })
  }
  const onAnswerChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange({ ...faq, answer: e.target.value })
  }
  const handleDelete = () => {
    onDelete(faq.id)
  }
  return (
    <div className="flex items-start rounded-2xl tc-mv-blur p-4 w-full mb-4 h-fit">
      <div className="flex-1 flex flex-col">
        <input
          type="text"
          className="px-4 bg-transparent text-white rounded-none w-full h-10 border-b border-white/15"
          value={faq.question}
          onChange={onQuestionChange}
          placeholder="Enter question here..."
        />
        <textarea
          className="px-4 bg-transparent text-white w-full rounded-none resize-none outline-none border-none p-2 min-h-12"
          style={
            {
              fieldSizing: 'content',
            } as React.CSSProperties
          }
          value={faq.answer}
          onChange={onAnswerChange}
          placeholder="Enter answer here..."
        />
      </div>
      <button onClick={handleDelete} className="w-10 h-10">
        <i className="fa-solid fa-trash" />
      </button>
    </div>
  )
})

export { FaqItem }
